import * as React from 'react';

import Department from '../../../component/Department';
import { addDepartment } from '../../../action/admin/Department';
import Loader from '../../../component/common/Loader';
import { validateForm } from '../../../utils';
import CONSTANT from '../../../constant';

class AddDepartment extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showLoader: false
        }
    }

    public render() {
        const { showLoader } = this.state
        return (
            <React.Fragment>
                <section>
                    <div className="col-lg-12 main-container">
                        <div className="fluid-container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="col-lg-12 mt-4">
                                        <div className="row">
                                            <div className="col-lg-6 pl-0">
                                                <h5 className="heading-h1">Add Department Skills</h5>
                                            </div>
                                        </div>
                                    </div>

                                    <Department
                                        onSubmit={this.onSubmit}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {
                    showLoader && <Loader />
                }
            </React.Fragment>

        )
    }

    onSubmit = (model: any) => {
        this.setState({ showLoader: true });
        if (validateForm(this, model)) {
            addDepartment(model)
                .then((res: any) => {
                    alert('Record Update Successfully')
                    this.setState({ showLoader: false });
                    this.props.history.push(CONSTANT.url.departmentList)
                })
        }
    }

}

export default AddDepartment;